/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Observable } from 'rxjs';
import { BaseApi } from './BaseApi';

export class SurveySourcesApi extends BaseApi {
  endPoint: string = '/api/admin/surveys/sources';

  public findByCodeExpanded(code: any): Observable<any> {
    const dynamicEndPoint = this.endPoint + '/code/:code/expanded';
    const _routeParams = {
      code: code
    };
    return this._get(dynamicEndPoint, _routeParams);
  }
}
